module.exports = __webpack_public_path__ + "static/media/68_brushed_dark_bronze_seamless.c860ae20.jpg";